export default "__VITE_ASSET__D_KZWUU9__"